import React from "react";
import "./Footer.scss";

function Footer() {
    return(
        <footer className="footer">
            <p className="footer__text">&#169; Мария Мантусова</p>
        </footer>
    )
}

export default Footer;
